import { render, staticRenderFns } from "./CurrentLeftMenu.vue?vue&type=template&id=466d164e"
import script from "./CurrentLeftMenu.vue?vue&type=script&lang=js"
export * from "./CurrentLeftMenu.vue?vue&type=script&lang=js"
import style0 from "./CurrentLeftMenu.vue?vue&type=style&index=0&id=466d164e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports